import FeedCard from "components/organisms/FeedCard/index"

export default function FeedNewItemCard({ feed, index }: { feed: NewItemFeed; index: number }) {
  return (
    <FeedCard key={index} type={feed.type}>
      <FeedCard.Title type={feed.type} date={feed.date}/>
      <FeedCard.ContentWrapper>
        <FeedCard.User user={feed.item?.user}/>
        <FeedCard.Divider/>
        <FeedCard.Summary type={feed.type} info={feed} index={index}/>
      </FeedCard.ContentWrapper>
    </FeedCard>
  )
}
